import React from 'react';

import { MenuItem, Select } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { goToGrowthTabularPage } from 'constants/helper';

import { editJobFunctionLevel } from 'services/growth/admin';

import { useJobFunctionsDataContext, useSelectedJobFunctionContext } from '../../GrowthSettings';
import { TABLE_DATA_ACTIONS, OTHER_ACTIONS, RETRY_COUNT } from '../GrowthTableContext';
import { StyledRoleHeaderCell } from '../GrowthTableHelperComps';
import RoleHeaderCell from './RoleHeaderCell';

const RoleHeader = ({ roles = [], layoutReducerDispatch, isLoading }) => {
  const history = useHistory();
  const { jobFunctions } = useJobFunctionsDataContext();
  const { selectedJobFunction, setSelectedJobFunction } = useSelectedJobFunctionContext();
  const onEdit = (name, uuid) => {
    layoutReducerDispatch({
      type: TABLE_DATA_ACTIONS.UPDATE_ROLE_NAME,
      payload: {
        name,
        uuid,
      },
    });

    // not a good design.
    let retryCount = RETRY_COUNT;

    const makeApiCall = () =>
      editJobFunctionLevel({
        uuid,
        name,
        jobFunctionId: selectedJobFunction.uuid,
      })
        .then((res) => {
          console.log('response', res);
        })
        .catch((err) => {
          if (retryCount !== 0) {
            retryCount--;
            makeApiCall();
          } else {
            layoutReducerDispatch({
              type: OTHER_ACTIONS.SET_ERROR,
              payload: {},
            });
            console.error(err);
          }
        });

    makeApiCall();
  };

  const handleJobFunctionSelect = (ev) => {
    const selectedJobFunctionId = ev.target.value;
    const selectedObj = jobFunctions.find(({ uuid }) => uuid === selectedJobFunctionId);
    setSelectedJobFunction(selectedObj);
    goToGrowthTabularPage(history, selectedJobFunctionId);
  };

  return (
    <StyledRoleHeader>
      <StyledRoleHeaderCell
        fixed
        style={{
          paddingRight: '12px',
        }}
      >
        <StyledSelect
          fullWidth
          variant="outlined"
          labelId="job-function-select"
          id="job-function-select"
          value={selectedJobFunction.uuid}
          onChange={handleJobFunctionSelect}
          MenuProps={{
            disablePortal: true,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
        >
          {jobFunctions.map(({ uuid, name }) => (
            <MenuItem value={uuid} style={{ fontSize: '14px' }}>
              {name}
            </MenuItem>
          ))}
        </StyledSelect>
      </StyledRoleHeaderCell>
      {roles.map((role, ind) => (
        <RoleHeaderCell
          isLoading={isLoading}
          index={ind}
          levelCount={roles.length}
          uuid={role.uuid}
          key={role.uuid}
          label={role.name}
          onEdit={onEdit}
          layoutReducerDispatch={layoutReducerDispatch}
        />
      ))}
    </StyledRoleHeader>
  );
};

const StyledRoleHeader = styled.div`
  display: flex;
  width: min-content;
  position: sticky;
  top: 0px;
  z-index: 2;

  > div:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  > div:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
`;

const StyledSelect = styled(Select)`
  font-size: 14px;

  .MuiMenu-paper {
    max-height: 40vh;
    overflow-y: scroll;
  }

  .MuiSelect-outlined {
    border: none;
    padding: 0.5rem 0rem;

    background-color: white !important;

    &:focus {
      background-color: white !important;
    }
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }
`;

export default RoleHeader;
